import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import HttpBackend from 'i18next-http-backend';
import LocizeBackend from 'i18next-locize-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { isDev } from 'services/env-service';

const USE_LOCAL = isDev() && true;

i18n
    .use(USE_LOCAL ? HttpBackend : LocizeBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // lng: 'en',
        fallbackLng: 'en',
        debug: isDev(),
        ns: ['common', 'sidebar', 'settings', 'project', 'team', 'chat', 'user', 'notifications', 'apps', 'addons', 'task', 'time-tracking', 'billing', 'file', 'fields', 'date', 'doc', 'labels', 'milestone', 'recurring', 'app-loading', 'errors', 'filter', 'subteam', 'onboarding', 'search', 'folder'],
        defaultNS: 'common',

        backend: USE_LOCAL ? {
            loadPath: '/locales/{{lng}}/{{ns}}.json'
        } : {
            projectId: 'ad8ea6cd-0247-404f-a36c-11ecb318109e',
            apiKey: 'd44dc2dc-1780-4e98-b2a0-be9a1069ae48',
            referenceLng: 'en'
        },

        react: {
            useSuspense: false
        },

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });

export default i18n;
